import React, { useContext } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Fab from "@mui/material/Fab";
import { Link } from "react-router-dom";
import ContactsIcon from "@mui/icons-material/Contacts";
import { useDispatch } from "react-redux";

const InClinicRow = (props) => {
  const dispatch = useDispatch();

  const clickHandler = () => {
    dispatch({
      type: "assign",
      payload: {
        prevRoute: "/lab/orders/view",
        index: 1,
      },
    });
  };

  return (
    <React.Fragment>
      <TableRow hover="true">
        <TableCell align="center">
          <Link
            to={`/lab/orders/view/${props.orderId}`}
            style={{ color: "inherit", textDecoration: "inherit" }}
          >
            <Fab color="secondary" size="small" onClick={clickHandler}>
              <ContactsIcon />
            </Fab>
          </Link>
        </TableCell>
        <TableCell align="center">{props.boxNumber}</TableCell>
        <TableCell align="center">{props.startDate}</TableCell>
        <TableCell align="center">{props.patientName}</TableCell>
        <TableCell align="center">{props.doctorName}</TableCell>
        <TableCell align="center">{props.orderType}</TableCell>
        <TableCell align="center">{props.lastExit}</TableCell>
      </TableRow>
      <TableRow></TableRow>
    </React.Fragment>
  );
};
export default InClinicRow;
